var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"color/all",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M17,1.01L7,1C5.9,1,5.01,1.9,5.01,3v18c0,1.1,0.89,2,1.99,2h10c1.1,0,2-0.9,2-2V3C19,1.9,18.1,1.01,17,1.01z M17,19H7V5 h10V19z M11,13H9l4-7.5V11h2l-4,7.5V13z","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }